import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Flag } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { flagApi, ticketPath, FLAG_UPDATED_EVENT, FLAG_STATUS_STYLES } from './flagUtils';

export const NeedsReviewFlagsCard = () => {
  const [flags, setFlags] = useState([]);
  const load = useCallback(() => flagApi.mine().then(setFlags).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    window.addEventListener(FLAG_UPDATED_EVENT, load);
    return () => { clearInterval(t); window.removeEventListener(FLAG_UPDATED_EVENT, load); };
  }, [load]);
  if (!flags.length) return null;
  return (
    <Card className="card-shadow border-orange-200 dark:border-orange-800" data-testid="needs-review-card">
      <CardHeader className="flex flex-row items-center justify-between">
        <div className="flex items-center gap-2">
          <Flag className="w-5 h-5 text-orange-500" />
          <div>
            <CardTitle className="text-lg">Needs Review</CardTitle>
            <CardDescription>Caseload Reviews flagged for correction</CardDescription>
          </div>
        </div>
        <Badge className="bg-orange-100 text-orange-800" data-testid="needs-review-count">{flags.length} open</Badge>
      </CardHeader>
      <CardContent className="space-y-2">
        {flags.map((f) => (
          <div key={f.id} className="p-3 rounded-lg border border-orange-200 bg-orange-50/50 dark:bg-orange-900/10 dark:border-orange-800" data-testid={`needs-review-flag-${f.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-medium text-sm truncate">{f.participant_name}</p>
                  <Badge variant="outline" className={`text-[10px] ${FLAG_STATUS_STYLES[f.status]}`}>{f.status}</Badge>
                </div>
                <p className="text-xs text-muted-foreground">Week of {f.week_of_date} · Flagged by {f.flagged_by_name}</p>
                <p className="text-xs text-orange-700 dark:text-orange-400 mt-1 line-clamp-1">&ldquo;{f.comments}&rdquo;</p>
              </div>
              <Button size="sm" variant="outline" className="shrink-0 border-orange-400 text-orange-700 hover:bg-orange-100" asChild data-testid={`needs-review-open-${f.id}`}>
                <Link to={ticketPath(f.id)}>{f.status === 'Pending Management Review' ? 'View Ticket' : 'Open Ticket'}</Link>
              </Button>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
